import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { ENPOINT } from '../endpoint';

import { Options } from 'selenium-webdriver/safari';
import { GLOBAL } from '../global';

@Injectable()
export class InvoicesVendorService {

  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;


  cargarFactura(cfdi, proveedor, form, fd): Observable<any> {
    const params = fd;
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders().set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('sinCfdi', cfdi)
      .set('proveedor', proveedor)
      .set('moneda', form.monedaForm)
      .set('total', form.importe)
      .set('contacto', form.correo)
      .set('responsable', form.correo2)
      .set('sociedad', form.sociedadForm)
    };
    return this.http.post(this.basePath + 'factsoc-fb60/carga', params, options);
  }

  cargarFacturaMasiva(usuario, body): Observable<any> {
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders()
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.post(this.basePath + 'facturas-batch/createBatchExcel/'+usuario, body, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/invoices-vendor/invoices-vendor.service.ts